module.exports = __webpack_public_path__ + "static/media/logo.92bfc368.png";